/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from "react";
import {
    AppBar,
    Box,
    Divider,
    Grid,
    IconButton,
    Toolbar,
    Typography,
    useMediaQuery,
    Tooltip,
    Avatar,
    Menu,
    MenuItem,
    Badge,
    ListItem,
    Button,
    Backdrop,
} from "@mui/material";
import LogoPTT from "../../assets/Image/logo-ptt-white.png";
import Training from "../../assets/Image/ImgProduct/Training.png";
import './Appbar.css'
import {
    Drawer,
    List,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { AlertMsg, AlertTitle,  AxiosGet, AxiosGetAD, AxiosPost, NoPermission, NoPermissionVOC, ResultAPI } from "service/CommonFunction/TS_function";
import { Link, NavLink } from "react-router-dom";
import DialogRegister from "view/FrontEnd/Register/DialogRegister";
import DialogLogin from "view/FrontEnd/Register/DialogLogin";
import { FaSignOutAlt } from "react-icons/fa";
import ListHeadMenu from "layout/LayoutBack/Menu/ListHeadMenu";
import { SwAlert } from "components/Common/Alert/AlertForm";
import { useLocation, useNavigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import DialogForgetPassword from "view/FrontEnd/Register/DialogForgetPassword";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import NotificationsIcon from '@mui/icons-material/Notifications';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from "moment";
import UserAvatar from "../../assets/Image/user-avatar.png";
import VpnKeyRoundedIcon from '@mui/icons-material/VpnKeyRounded';
import PermIdentityRoundedIcon from '@mui/icons-material/PermIdentityRounded';
import { AuthToken, currentLanguage } from "service/CommonFunction/AxiosConfig";
import secureLocalStorage from "react-secure-storage";
import { i18n } from "i18n";
import jwt_decode from "jwt-decode";

const i18nField = 'entities.Menu.fields';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    title: {
        flexGrow: 1,
        color: 'black'
    },
    appBarTransparent: {
        // background: 'linear-gradient(180deg, rgba(56,98,156,0.9164040616246498) 0%, rgba(255,255,255,0) 100%)'
        background: 'tranparent'
    },
    appBarSolid: {
        background: '#38629c !important'
    }
}));

const Appbar = (props) => {

    const { dataMenu, DataUser, setDataUser, lstProduct, objService } = props;
    const classes = useStyles();
    const [sidebar, setSidebar] = React.useState(false);


    const navigate = useNavigate();
    const location = useLocation();

    const isMatchMobile = useMediaQuery('(min-width:1436px)');
    const Layout475 = useMediaQuery('(min-width:475px)');
    const Layout700 = useMediaQuery('(min-width:700px)');
    const Layout1000 = useMediaQuery('(min-width:1000px)');
    const [openBackDrop, setOpenBackDrop] = React.useState(false);

    const navRef = React.useRef(null)
    const [navBackground, setNavBackground] = useState('appBarTransparent')
    const [openDrawer, setOpenDrawer] = useState(false);
    const [IsPopUpRegister, setIsPopUpRegister] = useState(false)
    const [IsPopUpLogin, setIsPopUpLogin] = useState(false)
    const [IsPopUpForgot, setIsPopUpForgot] = useState(false)
    const [sPathMenu] = useState(["/Front/MyVOC", "/Front/Profile", "/Front/MyVOC/HomeVOCForm", "/Front/MyVOC/HomeProductService", "/Front/MyVOC/HomeSuggestion", "/Front/MyVOC/LiveChatVOC", "/User/Verify"])
    const [sPathPrdService] = useState(["/reqtrainin", "/reqservice", "/reqproduct", "/Front/Prod", "/Front/Serv", "/Front/Trai", "/Front/Deta", "/Front/Publ"])

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const IsOpenNotify = Boolean(anchorEl);

    const [items, setItems] = useState([]);
    const [hasMore, sethasMore] = useState(true);
    const [nAllNotify, setnAllNotify] = useState(99)
    const [IshaveNotRead, setIshaveNotRead] = useState(false)
    const [cActivePath, setcActivePath] = useState(false)
    const [IsOpenSub, setIsOpenSub] = useState(false)

    useEffect(() => {
        GetNotify(0);
    }, [location.pathname])

    useEffect(() => {
        const queryString = location.search;
        const urlParams = new URLSearchParams(queryString);
        const token = urlParams.get("token");
        const language = urlParams.get("lang");
        

        if (token != null && token != "") {
            onAutoLoginAD(token)
        }
        let sLanguage = "th";
        if (language != null && language != "") {
            sLanguage = language.toLocaleLowerCase() == "en" ? "en" : "th";
            secureLocalStorage.setItem('languageUvoice', sLanguage);
            let sLang = secureLocalStorage.getItem('languageUvoice') + ""
            if(sLang != language)
            {
                window.location.reload();
            }
        }
    }, [location.search])

    useEffect(() => {
        const queryString = location.search;
        const urlParams = new URLSearchParams(queryString);
        const strMail = urlParams.get("strMail");
        const strUser = urlParams.get("strUser");

        if(strMail && strUser == "C")
        {
            let LinkTo = window.location.href;
            secureLocalStorage.setItem("LinkTo",LinkTo)
            secureLocalStorage.setItem("sUserType",strUser)
            onCheckTokenExpired(LinkTo);
        } 

    }, [])

    useEffect(() => {
        AxiosGet(`Authentication/CheckUserPermission`, { sPath: location.pathname }, (res) => {
            ResultAPI(res, null, () => {
                if (!res.IsHasPermission) {
                    NoPermission()
                }
            })
        })

        setcActivePath(sPathPrdService.includes(location.pathname.substring(0, 11)))

        navRef.current = navBackground
        if (!sPathMenu.includes(location.pathname)) {
            const handleScroll = () => {
                const show = window.scrollY > 10
                if (show) {
                    setNavBackground('appBarSolid')
                    navRef.current = 'appBarSolid';
                } else {
                    setNavBackground('appBarTransparent')
                    navRef.current = 'appBarTransparent';
                }
            }
            document.addEventListener('scroll', handleScroll)
            // return () => {
            //     document.removeEventListener('scroll', handleScroll)
            // }
        }
    }, [location.pathname])

    window.onclick = function (e) {
        if (!e.target.matches('.dropbtn-sub')) {
            var myDropdown = document.getElementById("myDropdown");
            if (myDropdown) {
                if (myDropdown.classList) {
                    if (myDropdown.classList.contains('show-sub')) {
                        myDropdown.classList.remove('show-sub');
                    }
                }
            }
        }
    }

    const onCheckTokenExpired = (LinkTo) => {
        let sToken = AuthToken.get() as string;
        let strUser = secureLocalStorage.getItem("sUserType") as string;
        if (sToken) {
            let decodedHeader = jwt_decode(sToken) as any;
            let nowDate = new Date();
            const dExp = new Date(0);
            dExp.setUTCSeconds(decodedHeader.exp);//Fix Date Exp
            if (dExp.valueOf() > nowDate.valueOf()) {
                //ยังไม่หมดอายุ
                // AuthToken.set(sToken);
                //Link To Path
                if(strUser == decodedHeader.USER_TYPE )
                {
                    if(LinkTo != window.location.href)
                    {
                        onGetLinkAndGotoLink();
                    }
                }
                else
                {
                    //No permission
                    NoPermissionVOC();
                }

                // if(strUser == decodedHeader.USER_TYPE && LinkTo != window.location.href)
                // {
                //     onGetLinkAndGotoLink();
                // }
                // else
                // {
                //     navigate("/Home")
                //     window.location.reload();
                // }
            }
            else
            {
                if(strUser == "E")
                {
                    //ให้ไป LoginAD
                    onGotoLoginAD();
                }
            }
        }
        else
        {
            // if (strUser == "C") {
            //     setIsPopUpLogin(true)
            // }
        }
    }

    const onGetLinkAndGotoLink =()=>{
        setOpenBackDrop(false)

        let sLinkTo = secureLocalStorage.getItem("LinkTo") as string;
        secureLocalStorage.removeItem("LinkTo");
        secureLocalStorage.removeItem("sUserType");
        
        if(sLinkTo && sLinkTo != "")
        {
            let anchor = document.createElement("a");
            anchor.href = sLinkTo;
            anchor.click();
        }
        else
        {
            navigate("/Home")
            window.location.reload();
        }
    }

    const onGotoLoginAD =()=>{
        let sSiteAD = process.env.REACT_APP_LOGINAD;
        let anchor = document.createElement("a");
        anchor.href = sSiteAD;
        anchor.click();
    }

    const onAutoLoginAD = (sToken) => {
        setOpenBackDrop(true)
        AxiosGetAD(`Authentication/LoginAD`, {}, (res) => {
            ResultAPI(res, null, () => {
                if (res.result?.token) {
                    AuthToken.set(res.result.token)
                    onGetLinkAndGotoLink();
                    window.location.reload();
                }

            })
        }, null, null, sToken)
    }


    const showSidebar = () => {
        setOpenDrawer(false)
        setSidebar(!sidebar);
    }

    const handleClickAppbar = () => {
        document.getElementById("myDropdown").classList.toggle("show-sub");
        setIsOpenSub(!IsOpenSub)
    };



    const onHandleLogout = (isFront: boolean) => {
        SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.confirmLogout, () => {
            secureLocalStorage.clear();
            secureLocalStorage.setItem('languageUvoice', "th");

            setDataUser(null)
            navigate("/Home");
            window.location.reload();
        });

    }

    const ReadNotify = (nNotifyID) => {
        AxiosGet(`Notify/ReadNotify`, { "nNotifyID": nNotifyID }, (res) => {
            ResultAPI(res, null, async () => {
                setAnchorEl(null);
            })
        })
    };

    const GetNotify = (length) => {
        let data = {
            Itemlength: length
        };
        AxiosPost(`Notify/GetMoreNotify`, data, (res) => {
            ResultAPI(res, null, async () => {
                let ArrNotify = res.ArrNotify || [];
                setItems([...ArrNotify])
                setnAllNotify(res.nCountComponent)
                setIshaveNotRead(res.IshaveNotRead)
            })
        })
    };

    const fetchMoreData = () => {
        let arr = [...items];

        if (arr.length > 0) {
            if (arr.length >= nAllNotify) {
                sethasMore(false);
            }
            else {
                if (items.length > 0) {
                    sethasMore(true);
                }
                let data = {
                    Itemlength: items.length || 0
                };
                AxiosPost(`Notify/GetMoreNotify`, data, (res) => {
                    ResultAPI(res, null, async () => {
                        let ArrNotify = res.ArrNotify || [];
                        setItems([...arr, ...ArrNotify])
                        setnAllNotify(res.nCountComponent)
                        setIshaveNotRead(res.IshaveNotRead)
                        if (ArrNotify.length == 0) {
                            sethasMore(false);
                        }
                    })
                })
            }
        }
    };

    const onChangeLang =(sLang)=>{
        // sLang : th/en
        document.cookie = "languageUvoice=" + sLang;
        secureLocalStorage.setItem('languageUvoice', sLang);
        window.location.reload();
    }


    const ListNotify = () => {
        return (
            <Menu
                anchorEl={anchorEl}
                id="scrollableDiv"
                open={IsOpenNotify}
                onClose={() => { 
                    setAnchorEl(null); 
                    GetNotify(0); 
                    setnAllNotify(99);
                    sethasMore(true); 
                }}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        width: 320,
                        height: 300,
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <InfiniteScroll
                    dataLength={items.length}
                    next={fetchMoreData}
                    height={290}
                    hasMore={hasMore}
                    loader={items.length > 0 ? <h4 style={{ textAlign: 'center' }}>...</h4> : null}
                    scrollableTarget="scrollableDiv"
                >
                    <div key={`notify_head`} className={'sticky-notify'}>
                        <Typography style={{ padding: '6px 12px', fontSize: '0.7em' }}>{currentLanguage() == "th" ? "การแจ้งเตือน" : "Notification"}</Typography>
                        <Divider />
                    </div>
                    <div key={`notify_item`} >
                        {items.map((item, ind) => {
                            let nJobTypeID = item?.nJobTypeID;
                            let nVOCFormTypeID = item?.nVOCFormTypeID;
                            return (
                                <Fragment key={`notify_${ind}`}>
                                    <MenuItem style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', padding: '2px 15px 2px 16px' }}>
                                        {
                                            item.isDate ?
                                                <div>
                                                    <Typography style={{ fontSize: '0.8em', fontWeight: 500 }}>{moment(item.dNotify).add(543, 'year').format("DD MMM YY")}</Typography>
                                                </div>
                                                :
                                                <Link
                                                    to={
                                                        //back
                                                        ((item.nNotifyTypeID == 5 && item.isJobCode == true) || item.nNotifyTypeID == 6) ? (nVOCFormTypeID == 2 ? "/Backend/VOCFormTrackingList/PageProductAndService"
                                                            : nJobTypeID === 1 ? "/Backend/VOCFormTrackingList/PageComplaint"
                                                                : nJobTypeID === 2 ? "/Backend/VOCFormTrackingList/PageRequest"
                                                                    : "/Backend/VOCFormTrackingList/PageSuggest")

                                                            //front
                                                            : (item.nNotifyTypeID == 5 && item.isJobCode == false && nVOCFormTypeID != 2? "/Backend/HomeBackEnd/PageClassifyIssue"
                                                                : item.nNotifyTypeID == 5 && nVOCFormTypeID == 2 ? "/Backend/VOCFormTrackingList/PageProductAndService"
                                                                : nVOCFormTypeID == 2 ? "/Front/MyVOC/HomeProductService"
                                                                    : (nJobTypeID === 1 || nJobTypeID === 2) ? "/Front/MyVOC/HomeVOCForm"
                                                                        : "/Front/MyVOC/HomeSuggestion")}
                                                    onClick={() => { ReadNotify(item.nNotifyID) }}
                                                    state={{ sVOCFormID: item.sVOCFormID, sMode: "Notify" }}
                                                    style={{ width: '100%' }}
                                                >
                                                    <div className="item-notify" style={{ width: '100%', position: 'relative', padding: '4px 9px 4px 12px' }}>
                                                        <div style={{ position: 'absolute', top: 4, right: 8, fontSize: '0.7em' }}>{item.dNotify != "" ? moment(item.dNotify).format("HH:mm") : ""}</div>
                                                        {item.isRead ? null : <div style={{ position: 'absolute', top: '11px', left: '-15px' }}><FiberManualRecordIcon style={{ fontSize: '8px', color: '#7a00ff' }} /></div>}
                                                        <Typography style={{ fontSize: '0.8em', fontWeight: 500 }}>{item.sVOCFormCode ?? ""}</Typography>
                                                        <Typography style={{ fontSize: '0.8em' }}>{currentLanguage() == "th" ? item?.sNameTH : item?.sNameEN}</Typography>
                                                    </div>
                                                </Link>
                                        }
                                    </MenuItem>
                                </Fragment>
                            )
                        })}
                    </div>
                </InfiniteScroll>

            </Menu>

        )
    }

    const onHandleOpenNotify = (event) => {
        GetNotify(0);
        setAnchorEl(event.currentTarget);
    }

    return (
        <div className={classes.root}>
            <AppBar
                className={sPathMenu.includes(location.pathname) || !Layout1000 ? classes["appBarSolid"] : classes[navRef.current]}
            >
                <Toolbar style={{ minHeight: '64px', paddingRight: '0px', ...!Layout475 ? { paddingLeft: '0px' } : {} }}>
                    {!isMatchMobile ? (
                        // Mobile
                        <>
                            <Grid container justifyContent={'space-between'} alignItems='center' >
                                <Grid item xs={'auto'}>
                                    <Grid container alignItems='center' sx={{ flexGrow: 1, }} >
                                        <Grid item xs={'auto'}>
                                            <IconButton
                                                sx={{ color: "white" }}
                                                onClick={() => setOpenDrawer(!openDrawer)}
                                            >
                                                <MenuIcon style={{ fontSize: Layout700 ? '2rem' : '1.5rem', color: '#ffffff' }} />
                                            </IconButton>
                                        </Grid>
                                        <Grid item xs={'auto'}>
                                            <Link to="/Home" preventScrollReset={true}>
                                                {/* <img
                                                    alt={"PTT Logo"}
                                                    style={{ cursor: "pointer", objectFit: "contain", width: Layout700 ? '100px' : '70px' }}
                                                    src={LogoPTT}
                                                    onClick={() => { }}
                                                /> */}
                                                <Box
                                                    component="div"
                                                    sx={{
                                                        flexGrow: 1,
                                                        backgroundImage: `url(${LogoPTT})`,
                                                        backgroundSize: "cover",
                                                        backgroundRepeat: "no-repeat",
                                                        objectFit: 'contain',
                                                        cursor: 'pointer',
                                                        height: '43px',
                                                        width: '100px',
                                                        margin: '7px'
                                                    }}
                                                />
                                            </Link>
                                        </Grid>
                                        <Divider orientation="vertical" variant="middle" flexItem style={{ margin: '0px 6px', border: '0.5px solid #ffffff', backgroundColor: '#ffffff' }} />
                                        <Grid item xs={'auto'}>
                                            <Typography color={"white"} style={{ lineHeight: "0.9" }}>
                                                <span style={{ fontWeight: "700", display: "flex", fontSize: Layout700 ? "30px" : !Layout475 ? "0.8em" : "1em" }}>
                                                    GBU
                                                </span>{" "}
                                                <span style={{ fontWeight: "200", fontSize: Layout700 ? "25px" : !Layout475 ? "0.8em" : "1em" }}>
                                                    <span style={{ fontWeight: "500" }}>VOICE</span> OF CUSTOMER
                                                </span>
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={'auto'} style={{ display: 'flex', alignItems: 'center' }}>
                                    {
                                        DataUser?.nUserID == null || DataUser?.nUserID === 0 ?
                                            <>
                                            </>
                                            :
                                            <>
                                                <Grid container direction={'row'} spacing={0} justifyContent={'end'} alignItems='center' style={{ minHeight: '64px' }}>
                                                    <Grid item>
                                                        <IconButton
                                                            sx={{ color: "white", marginLeft: "auto" }}
                                                            onClick={(event: React.MouseEvent<HTMLElement>) => { onHandleOpenNotify(event) }}
                                                        >
                                                            {IshaveNotRead == false ?
                                                                <NotificationsIcon style={{ fontSize: '1.5rem' }} />
                                                                :
                                                                <Badge color="error" variant="dot">
                                                                    <NotificationsActiveIcon style={{ fontSize: '1.5rem' }} />
                                                                </Badge>
                                                            }
                                                        </IconButton>
                                                    </Grid>
                                                    {
                                                        Layout1000 ?
                                                            <>
                                                                <Grid item>
                                                                    <Tooltip title="Profile">
                                                                        <Link to="/Front/Profile" preventScrollReset={true}>
                                                                            <IconButton>
                                                                                <Avatar src={DataUser?.sPathImage ?? UserAvatar} />
                                                                            </IconButton>
                                                                        </Link>
                                                                    </Tooltip>
                                                                </Grid>

                                                                <Grid item style={{ maxWidth: '180px' }}>
                                                                    <div >
                                                                        <Grid container direction={'column'} spacing={0} justifyContent={'center'} alignItems='end' style={{ minHeight: '64px' }}>
                                                                            <Grid item xs={'auto'}>
                                                                                <p className="appbar-name">{DataUser?.sFullname}</p>
                                                                            </Grid>
                                                                            <Grid item xs={'auto'} >
                                                                                <p className="appbar-intro">{DataUser?.sCompany}</p>
                                                                            </Grid>
                                                                            {
                                                                                DataUser && DataUser.sBA != null
                                                                                    ?
                                                                                    <Grid item xs={'auto'} >
                                                                                        <p className="appbar-intro">{i18n(`${i18nField}.sMarket`)}: {DataUser?.sBA}</p>
                                                                                    </Grid>
                                                                                    : null
                                                                            }
                                                                        </Grid>
                                                                    </div>

                                                                </Grid>

                                                            </>
                                                            : null
                                                    }
                                                    <Grid item>
                                                        <Tooltip title="ออกจากระบบ">
                                                            <IconButton onClick={() => { onHandleLogout(true) }}>
                                                                <FaSignOutAlt style={{ color: '#ffffff' }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid>
                                                </Grid>
                                            </>
                                    }
                                </Grid>
                            </Grid>
                        </>
                    ) : (
                        // WEB
                        <>
                            <Grid container spacing={2} justifyContent={'space-between'} alignItems='center' sx={{ marginLeft: '0px' }} >
                                <Grid item>
                                    <Grid container alignItems='center' >
                                        <Grid item xs={'auto'}>

                                            <Link to="/Home" preventScrollReset={true}>
                                                    {/* <img
                                                        alt={"PTT Logo"}
                                                        style={{ cursor: "pointer", objectFit: "contain" }}
                                                        width="100px"
                                                        src={LogoPTT}
                                                    /> */}
                                                    <Box
                                                        component="div"
                                                        sx={{
                                                            flexGrow: 1,
                                                            backgroundImage: `url(${LogoPTT})`,
                                                            backgroundSize: "cover",
                                                            backgroundRepeat: "no-repeat",
                                                            objectFit: 'contain',
                                                            cursor: 'pointer',
                                                            height: '43px',
                                                            width: '100px',
                                                            margin:'7px'
                                                        }}
                                                    />
                                            </Link>
                                        </Grid>
                                        <Divider orientation="vertical" variant="middle" flexItem style={{ margin: '4px 8px 4px', border: '0.5px solid rgb(255 255 255 / 29%)', backgroundColor: '#ffffff' }} />
                                        <Grid item xs={'auto'}>
                                            <Typography color={"white"} style={{ lineHeight: "0.9" }}>
                                                <span style={{ fontWeight: "700", display: "flex", fontSize: "30px" }}>
                                                    GBU
                                                </span>{" "}
                                                <span style={{ fontWeight: "200", fontSize: "25px" }}>
                                                    <span style={{ fontWeight: "500" }}>VOICE</span> OF CUSTOMER
                                                </span>
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container alignItems='center' >
                                        <Grid item xs={'auto'}>
                                            <div className="topnav navbar-sub" id="myTopnav">
                                                {dataMenu != null && dataMenu.length > 0 ?
                                                    dataMenu.map((item, index) => {
                                                        if (item?.nMenuID == 2) {
                                                            return (
                                                                <span key={`prs-sv_${index}`} className="dropdown-sub" style={{ backgroundColor: cActivePath ? '#096ddd' : 'transparent !important' }}>
                                                                    <span className="dropbtn-sub" onClick={() => { handleClickAppbar() }}>{currentLanguage() == "th" ? item?.sMenuNameTH : item?.sMenuNameENG}</span>
                                                                    <div className="dropdown-content-sub" id="myDropdown">
                                                                        <Grid container spacing={1} alignItems='start' >
                                                                            <Grid item xs={12}>
                                                                                <Typography className="title-prd">
                                                                                    {i18n(`${i18nField}.sProductsServices`)}
                                                                                </Typography>
                                                                            </Grid>
                                                                            <Divider style={{ width: '100%', marginTop: '0.5em', border: '1px solid', borderRadius: '50px' }} />
                                                                            <Grid item xs={12} sm={6}>
                                                                                <Grid container spacing={1} justifyContent={'center'} alignItems='start' >
                                                                                    <Grid item xs={12}>
                                                                                        <div className="menu-title-box" >
                                                                                            {i18n(`${i18nField}.sProducts`)}
                                                                                        </div>
                                                                                    </Grid>
                                                                                    {
                                                                                        lstProduct.length > 0
                                                                                            ?
                                                                                            <>
                                                                                                {
                                                                                                    lstProduct.map((item, ind) => {
                                                                                                        return (
                                                                                                            <Grid key={`s-prd-${ind}`} item xs={12} sm={4} >
                                                                                                                <span onClick={() => { navigate("/Front/Product?sID=" + item?.sProductID) }}>
                                                                                                                    <Grid container spacing={1} justifyContent={'center'} alignItems='start' >
                                                                                                                        <Grid item >
                                                                                                                            <img src={item?.sFileLink} alt='' className="menu-image" />
                                                                                                                        </Grid>
                                                                                                                        <Grid item xs={12}>
                                                                                                                            <Typography style={{ textAlign: 'center' }}>
                                                                                                                                {item?.sProductName}
                                                                                                                            </Typography>
                                                                                                                        </Grid>
                                                                                                                    </Grid>
                                                                                                                </span>
                                                                                                            </Grid>

                                                                                                        )
                                                                                                    })
                                                                                                }
                                                                                            </>
                                                                                            : null
                                                                                    }

                                                                                </Grid>
                                                                            </Grid>
                                                                            <Grid item xs={12} sm={6}>
                                                                                <Grid container spacing={1} justifyContent={'center'} alignItems='start' >
                                                                                    <Grid item xs={12}>
                                                                                        <div className="menu-title-box" style={{ backgroundColor: '#0f3b6d' }}>
                                                                                            {i18n(`${i18nField}.sServices`)}

                                                                                        </div>
                                                                                    </Grid>
                                                                                    {
                                                                                        objService != null ?
                                                                                            <Grid item xs={12} sm={6}>
                                                                                                <span onClick={() => { navigate("/Front/Service?sID=" + objService?.sServiceID) }}>
                                                                                                    <Grid container spacing={1} justifyContent={'center'} alignItems='start' >
                                                                                                        <Grid item >
                                                                                                            <img src={objService?.sFileLink} alt='' className="menu-image-reg" />
                                                                                                        </Grid>
                                                                                                        <Grid item xs={12}>
                                                                                                            <Typography style={{ textAlign: 'center' }}>
                                                                                                                {objService?.sServiceName}
                                                                                                            </Typography>
                                                                                                        </Grid>
                                                                                                    </Grid>
                                                                                                </span>
                                                                                            </Grid>
                                                                                            : null
                                                                                    }
                                                                                    <Grid item xs={12} sm={6}>
                                                                                        <span onClick={() => { navigate("/Front/Training") }}>
                                                                                            <Grid container spacing={1} justifyContent={'center'} alignItems='start' >
                                                                                                <Grid item >
                                                                                                    <img src={Training} alt='' className="menu-image-reg" />
                                                                                                </Grid>
                                                                                                <Grid item xs={12}>
                                                                                                    <Typography style={{ textAlign: 'center' }}>
                                                                                                        {i18n(`${i18nField}.sTraining`)}
                                                                                                    </Typography>
                                                                                                </Grid>
                                                                                            </Grid>
                                                                                        </span>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </div>
                                                                </span>
                                                            )
                                                        }
                                                        else {
                                                            return (
                                                                <NavLink
                                                                    to={item.sMenuLink}
                                                                    key={index}
                                                                    className={({ isActive }) => isActive ? "active" : undefined}
                                                                // className={({ isActive }) => isActive && IsOpenSub == false ? "active" : undefined }
                                                                // onClick={()=>{setIsOpenSub(false)}}
                                                                >
                                                                    <Typography style={{ fontWeight: 500 }}>
                                                                        {currentLanguage() == "th" ? item?.sMenuNameTH : item?.sMenuNameENG}
                                                                    </Typography>
                                                                </NavLink>
                                                            )
                                                        }

                                                    })
                                                    : null}
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={'auto'} style={{ display: 'flex', alignItems: 'center' }}>
                                    {
                                        DataUser?.nUserID == null || DataUser?.nUserID === 0
                                            ?
                                            <>
                                                <span
                                                    className="btnRegis"
                                                    onClick={() => { setIsPopUpRegister(true) }}
                                                    style={{
                                                        width: '92px'
                                                    }}
                                                >
                                                    {i18n(`${i18nField}.sRegister`)}
                                                </span>
                                                <span
                                                    className="btnRegis"
                                                    onClick={() => { setIsPopUpLogin(true) }}
                                                >
                                                    {currentLanguage() == "th" ? <>เข้าใช้งาน<br />ระบบ</> : <>Log in</>}
                                                </span>
                                            </>
                                            :
                                            <>
                                                <Grid container direction={'row'} spacing={1} justifyContent={'end'} alignItems='center' style={{ minHeight: '64px' }}>
                                                    <Grid item>
                                                        <IconButton
                                                            sx={{ color: "white", marginLeft: "auto" }}
                                                            onClick={(event: React.MouseEvent<HTMLElement>) => { onHandleOpenNotify(event) }}
                                                        >
                                                            {IshaveNotRead == false ?
                                                                <NotificationsIcon style={{ fontSize: '1.5rem' }} />
                                                                :
                                                                <Badge color="error" variant="dot">
                                                                    <NotificationsActiveIcon style={{ fontSize: '1.5rem' }} />
                                                                </Badge>
                                                            }
                                                        </IconButton>
                                                    </Grid>
                                                    <Grid item>
                                                        <Tooltip title="Profile">
                                                            <Link to="/Front/Profile" preventScrollReset={true}>
                                                                <IconButton>
                                                                    <Avatar src={DataUser?.sPathImage ?? UserAvatar} />
                                                                </IconButton>
                                                            </Link>
                                                        </Tooltip>
                                                    </Grid>
                                                    <Grid item style={{ maxWidth: '180px' }}>
                                                        <div>
                                                            <Grid container direction={'column'} spacing={0} justifyContent={'center'} alignItems='end' style={{ minHeight: '64px' }}>
                                                                <Grid item xs={'auto'}>
                                                                    <p className="appbar-name">{DataUser?.sFullname}</p>
                                                                </Grid>
                                                                <Grid item xs={'auto'} >
                                                                    <p className="appbar-intro">{DataUser?.sCompany}</p>
                                                                </Grid>
                                                                {
                                                                    DataUser && DataUser.sBA != null
                                                                        ?
                                                                        <Grid item xs={'auto'} >
                                                                            <p className="appbar-intro">{i18n(`${i18nField}.sMarket`)}: {DataUser?.sBA}</p>
                                                                        </Grid>
                                                                        : null
                                                                }
                                                            </Grid>
                                                        </div>
                                                    </Grid>
                                                    <Grid item>
                                                        <Tooltip title="ออกจากระบบ">
                                                            <IconButton onClick={() => { onHandleLogout(true) }}>
                                                                <FaSignOutAlt style={{ color: '#ffffff' }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid>
                                                </Grid>
                                            </>
                                    }
                                    <span
                                        className="btnLang"
                                        onClick={() => { onChangeLang("th")}}
                                        style={
                                            currentLanguage() == "th" ?
                                                {
                                                    background: "linear-gradient(180deg, rgba(56,98,156,1) 21%, rgba(6,125,238,0.9136029411764706) 100%)",
                                                    color: '#ffffff',
                                                    borderRadius: DataUser?.nUserID == null || DataUser?.nUserID === 0 ? "0" : '50%',
                                                    minHeight: DataUser?.nUserID == null || DataUser?.nUserID === 0 ? "64px" : '30px',

                                                }
                                                :
                                                {
                                                    borderRadius: DataUser?.nUserID == null || DataUser?.nUserID === 0 ? "0" : '50%',
                                                    minHeight: DataUser?.nUserID == null || DataUser?.nUserID === 0 ? "64px" : '30px',

                                                }
                                        }
                                    >
                                        TH
                                    </span>
                                    <span
                                        className="btnLang"
                                        onClick={() => { onChangeLang("en")}}
                                        style={
                                            currentLanguage() == "en" ?
                                                {
                                                    background: "linear-gradient(180deg, rgba(56,98,156,1) 21%, rgba(6,125,238,0.9136029411764706) 100%)",
                                                    color: '#ffffff',
                                                    borderRadius: DataUser?.nUserID == null || DataUser?.nUserID === 0 ? "0" : '50%',
                                                    minHeight: DataUser?.nUserID == null || DataUser?.nUserID === 0 ? "64px" : '30px',
                                                }
                                                :
                                                {
                                                    borderRadius: DataUser?.nUserID == null || DataUser?.nUserID === 0 ? "0" : '50%',
                                                    minHeight: DataUser?.nUserID == null || DataUser?.nUserID === 0 ? "64px" : '30px',

                                                }
                                        }
                                    >
                                        EN
                                    </span>
                                </Grid>
                            </Grid>
                        </>
                    )}
                </Toolbar>
            </AppBar>

            {/* for mobile */}
            <Drawer
                anchor="left"
                open={openDrawer}
                onClose={() => setOpenDrawer(false)}
            >
                <Box
                    sx={{ width: 300, overflow: 'hidden' }}
                    role="presentation"
                    style={{
                        overflowY: 'auto'
                    }}
                >
                    {
                        DataUser?.nUserID == null || DataUser?.nUserID === 0 ?
                            null
                            :
                            <>
                                <div style={{ width: '100%', height: '225px', padding: '16px', background: 'linear-gradient(135deg,#c4edff,#ffe7f9)', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                                    <Grid container direction={'column'} spacing={1} justifyContent={'center'} alignItems='center'>
                                        <Grid item xs={'auto'}>
                                            <Tooltip title="Profile">
                                                <Link to="/Front/Profile" preventScrollReset={true}>
                                                    <IconButton>
                                                        <Avatar src={DataUser?.sPathImage ?? UserAvatar} style={{ width: '4.5em', height: '4.5em' }} />
                                                    </IconButton>
                                                </Link>
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={'auto'}>
                                            <p className="appbar-name">{DataUser?.sFullname}</p>
                                        </Grid>
                                        <Grid item xs={'auto'}>
                                            <p className="appbar-intro">{DataUser?.sCompany}</p>
                                        </Grid>
                                        {
                                            DataUser?.sBA != null
                                                ?
                                                <Grid item xs={'auto'}>
                                                    <p className="appbar-intro">{i18n(`${i18nField}.sMarket`)}: {DataUser?.sBA}</p>
                                                </Grid>
                                                : null
                                        }
                                    </Grid>
                                </div>
                            </>
                    }
                    <List>
                        <ListItem style={{ padding: '16px' }}>
                            <Grid container direction={'row'} spacing={1} justifyContent={'space-evenly'} alignItems='center'>
                                <Grid item xs={'auto'} style={{width : '35%'}}>
                                    <Button
                                        variant="outlined"
                                        onClick={() => { onChangeLang("th")}}
                                        sx={
                                            currentLanguage() == "th" ?
                                                {
                                                    background: "linear-gradient(180deg, rgba(56,98,156,1) 21%, rgba(6,125,238,0.9136029411764706) 100%)",
                                                    borderRadius: "12px",
                                                    minHeight: "42px",
                                                    textAlign: 'center',
                                                    color: '#ffffff',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    cursor:'pointer',
                                                    width:'100%',
                                                }
                                                :
                                                {
                                                    borderRadius: "12px",
                                                    minHeight: "42px",
                                                    textAlign: 'center',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    background: "linear-gradient(120deg, rgb(116 163 226), rgb(255 255 255))",
                                                    width:'100%',
                                                    ":hover": { background: "#83b3eb" },
                                                }
                                        }
                                    >
                                        TH
                                    </Button>
                                </Grid>
                                <Grid item xs={'auto'} style={{width : '35%'}}>
                                    <Button
                                        variant="outlined"
                                        onClick={() => { onChangeLang("en")}}
                                        sx={
                                            currentLanguage() == "en" ?
                                                {
                                                    background: "linear-gradient(180deg, rgba(56,98,156,1) 21%, rgba(6,125,238,0.9136029411764706) 100%)",
                                                    borderRadius: "12px",
                                                    minHeight: "42px",
                                                    textAlign: 'center',
                                                    color: '#ffffff',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    cursor:'pointer',
                                                    width:'100%',
                                                }
                                                :
                                                {
                                                    borderRadius: "12px",
                                                    minHeight: "42px",
                                                    textAlign: 'center',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    background: "linear-gradient(120deg, rgb(116 163 226), rgb(255 255 255))",
                                                    width:'100%',
                                                    ":hover": { background: "#83b3eb" },
                                                }
                                        }
                                    >
                                        EN
                                    </Button>
                                </Grid>
                            </Grid>
                        </ListItem>
                        <Divider />
                        <ListHeadMenu
                            dataMenu={dataMenu}
                            sidebar={sidebar}
                            fnShowSidebar={showSidebar}
                            isShowIcon={false}
                            setIsDrawerMenu={setOpenDrawer}
                        />
                        {
                            DataUser?.nUserID == null || DataUser?.nUserID === 0 ?
                                <>
                                    <ListItem style={{ display: 'flex', justifyContent: 'center' }}>
                                        <Button fullWidth onClick={() => { setOpenDrawer(false); setIsPopUpRegister(true) }} variant="outlined" startIcon={<PermIdentityRoundedIcon />}>
                                            {i18n(`${i18nField}.sRegister`)}
                                        </Button>
                                    </ListItem>
                                    <ListItem style={{ display: 'flex', justifyContent: 'center' }} >
                                        <Button fullWidth onClick={() => { setOpenDrawer(false); setIsPopUpLogin(true) }} variant="outlined" startIcon={<VpnKeyRoundedIcon />}>
                                            {/* {currentLanguage() == "th" ? "เข้าใช้งานระบบ" : "Log in"} */}
                                            {i18n(`${i18nField}.sLogin`)}
                                        </Button>
                                    </ListItem>
                                </>
                                :
                                null
                        }
                    </List>
                </Box>
            </Drawer>
            {ListNotify()}
            <DialogRegister
                open={IsPopUpRegister}
                setOpen={setIsPopUpRegister}
            />
            <DialogLogin
                open={IsPopUpLogin}
                setOpen={setIsPopUpLogin}
                setDataUser={setDataUser}
                setIsPopUpRegister={setIsPopUpRegister}
                setIsPopUpForgot={setIsPopUpForgot}
            />
                <DialogForgetPassword
                    open={IsPopUpForgot}
                    setOpen={setIsPopUpForgot}
                />
                <Backdrop
                sx={{ color: '#fff', zIndex: 99999 }}
                open={openBackDrop}
            >
                <div className="spinner">
                    <span className="ball-1"></span>
                    <span className="ball-2"></span>
                    <span className="ball-3"></span>
                    <span className="ball-4"></span>
                    <span className="ball-5"></span>
                    <span className="ball-6"></span>
                    <span className="ball-7"></span>
                    <span className="ball-8"></span>
                </div>
            </Backdrop>

        </div>
    );
};

export default Appbar;